import React from 'react'
import axios from 'axios';
import { toast, ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import API_URL from '../ApiUrl/ApiUrl';
const Contact = () => {

  const [formData, setFormData] = React.useState({
    first_name: '',
    last_name: '',
    organization_name: '',
    phone_number: '',
    email: '',
    address: '',
    start_date: '',
    end_date: '',
    vehicle_type: ''
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevFormData) => ({
      ...prevFormData,
      [name]: value
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const response = await axios.post(
        `${API_URL}/booking`,
        formData
      );
      toast.success('Form submitted successfully! ,We will get in touch with you in 24 hours', {
        position: "top-center"
      });
    } catch (error) {
      toast.error('Failed to submit the form. Please try again.');
    }
    setFormData({
      first_name: '',
      last_name: '',
      organization_name: '',
      phone_number: '',
      email: '',
      address: '',
      start_date: '',
      end_date: '',
      vehicle_type: ''
    })
  };


  return (
    <div>
      <ToastContainer />
      <div className="site-wrap" id="home-section">
        <div style={{ backgroundImage: "url(https://pricelessrentalsusa.com/wp-content/uploads/2023/07/mt-1582-home-header-bg-1.jpg)" }}>

          <div className="ftco-blocks-cover-1">
            <div className="ftco-cover-1 overlay innerpage">
              <div className="container">
                <div className="row align-items-center justify-content-center">
                  <div className="col-lg-6 text-center">
                    <h1>Contact Us</h1>
                    <p>
                      If you have any questions, feedback, or need assistance, feel
                      free to reach out to us. Our team is here to help you with
                      anything you need related to car rentals. Whether you're
                      planning a trip or need more information, we're happy to assist!
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="site-section bg-light" id="contact-section">
          <div className="container">
            <div className="row justify-content-center text-center">
              <div className="col-7 text-center mb-5">
                <h2>Reserve Your Ride</h2>
                <p>
                  Rent a car from our website, Dar es Salaam offices and embark on an
                  adventure to any region in Tanzania. Discover the beauty and
                  richness of the country while enjoying the comfort and
                  sophistication of our corporate vehicles. .
                </p>
              </div>
            </div>
            <div className="row">
              <div className="col-lg-8 mb-5">
                <form onSubmit={handleSubmit}>
                  <div className="form-group row">
                    <div className="col-md-6 mb-4 mb-lg-0">
                      <input
                        type="text"
                        className="form-control"
                        name="first_name"
                        placeholder="First Name"
                        value={formData.first_name}
                        onChange={handleChange}
                        required
                      />
                    </div>
                    <div className="col-md-6">
                      <input
                        type="text"
                        className="form-control"
                        name="last_name"
                        placeholder="Last Name"
                        value={formData.last_name}
                        onChange={handleChange}
                        required
                      />
                    </div>
                  </div>
                  <div className="form-group row">
                    <div className="col-md-6 mb-4 mb-lg-0">
                      <input
                        type="text"
                        className="form-control"
                        name="organization_name"
                        placeholder="Organization Name"
                        value={formData.organization_name}
                        onChange={handleChange}
                        required
                      />
                    </div>
                    <div className="col-md-6">
                      <input
                        type="tel"
                        className="form-control"
                        name="phone_number"
                        placeholder="Phone Number"
                        value={formData.phone_number}
                        onChange={handleChange}
                        required
                      />
                    </div>
                  </div>
                  <div className="form-group row">
                    <div className="col-md-12">
                      <input
                        type="email"
                        className="form-control"
                        name="email"
                        placeholder="Email"
                        value={formData.email}
                        onChange={handleChange}
                        required
                      />
                    </div>
                  </div>
                  <div className="form-group row">
                    <div className="col-md-12">
                      <input
                        type="text"
                        className="form-control"
                        name="address"
                        placeholder="Address"
                        value={formData.address}
                        onChange={handleChange}
                        required
                      />
                    </div>
                  </div>
                  <div className="form-group row">
                    <div className="col-md-6 mb-4 mb-lg-0">
                      <label>Start Date</label>
                      <input
                        type="date"
                        className="form-control"
                        name="start_date"
                        value={formData.start_date}
                        onChange={handleChange}
                        required
                      />
                    </div>
                    <div className="col-md-6">
                      <label>End Date</label>
                      <input
                        type="date"
                        className="form-control"
                        name="end_date"
                        value={formData.end_date}
                        onChange={handleChange}
                        required
                      />
                    </div>
                  </div>
                  <div className="form-group row">
                    <div className="col-md-12">
                      <select
                        className="form-control"
                        name="vehicle_type"
                        value={formData.vehicle_type}
                        onChange={handleChange}
                        required
                      >
                        <option value="" disabled>Select Vehicle Type</option>
                        <option value="Toyota Land Cruiser LC 300 Series">Toyota Land Cruiser LC 300 Series</option>
                        <option value="Toyota Land Cruiser 200 Series">Toyota Land Cruiser 200 Series</option>
                        <option value="prado150">Toyota Land Cruiser Prado 150 Series</option>
                        <option value="Toyota Land Cruiser Prado 150 Series">Toyota Fortuner Series</option>
                        <option value="Toyota Alphard">Toyota Alphard</option>
                        <option value="Nissan Xtrail">Nissan Xtrail</option>
                      </select>
                    </div>
                  </div>
                  <div className="form-group row">
                    <div className="col-md-6 mr-auto">
                      <button type="submit" className="btn btn-block btn-primary text-white py-3 px-5">
                        Submit
                      </button>
                    </div>
                  </div>
                  <p>We will get in touch with you in 24 hours.</p>
                </form>
              </div>
              <div className="col-lg-4 ml-auto">
                <div className="bg-white p-3 p-md-5">
                  <h3 className="text-black mb-4">Contact Info</h3>
                  <ul className="list-unstyled footer-link">
                    <li className="d-block mb-3">
                      <span className="d-block text-black">Address:</span>
                      <span>
                        Cardinal Rugambwa Social Center, Suit No. 09 Haile Selasie
                        Road, Oysterbay, P.O.Box 2340 Dar es Salaam, Tanzania.
                      </span>
                    </li>
                    <li className="d-block mb-3">
                      <span className="d-block text-black">Phone:</span>
                      <span>+255 757 900007</span>
                    </li>
                    <li className="d-block mb-3">
                      <span className="d-block text-black">Email:</span>
                      <span>office@premiumcarrentals.co.tz </span>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
          <p className="text-center">
            For inquiries and bookings, contact us call or WhatsApp at 0757900007.
          </p>
        </div>
     
      </div>

    </div>
  )
}

export default Contact